import React from 'react';
import Slug from '../../../../../views/components/slug/slug';
import MarketoForm from '../../../../../views/components/MarketoForm/MarketoForm';

const NewsletterPageMarketo = () => (
  <div>
    <Slug slugName="Newsletters" className="category-page" />
    <section className="newsletters__page__marketo">
      <div className="newsletters__page__marketo__form__container">
        <MarketoForm assetId={1018} />
      </div>
    </section>
  </div>
);

export default NewsletterPageMarketo;
